import React from "react"
import InfiniteScroll from "react-infinite-scroller"
import { Loading } from "../../components/parts/loading"
import { Wrapper } from "../../components/templates/wrapper"
import { Headline } from "../../components/parts/headline/headline"
import styled from "styled-components"
import { JSONRPCErrorCatch } from "../../error/error"
import { JSONRPCClientBuilder } from "../../request/JSONRPCClientBuilder"
import { Notification, UserRPC } from "../../rpcs/dist/UserRPC"
import Color from "../../style/enum/color"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBell } from "@fortawesome/free-solid-svg-icons"
import { NotificationItem } from "./components/item"
import { container, IContainerProps } from "./container"

// 1度の通信で取得できる通知の最大数
const MAXIMUM_NOTIFICATION_READ_AT_ONE_TIME = 10

interface IState {
  hasMore: boolean
}

class Component extends React.Component<IContainerProps, IState> {
  constructor(props: IContainerProps) {
    super(props)
    this.loadMore = this.loadMore.bind(this)
    this.bulkReadNotifications = this.bulkReadNotifications.bind(this)

    this.state = {
      hasMore: true,
    }
  }

  public render() {
    const { notifications } = this.props.notification
    return (
      <Wrapper>
        <Headline horizontalMargin={true}>
          <FontAwesomeIcon icon={faBell} /> お知らせ
        </Headline>
        <InfiniteScroll
          loadMore={this.loadMore}
          hasMore={this.state.hasMore}
          loader={<Loading key="loading" />}
        >
          {notifications.map(n => (
            <NotificationItem key={n.id} notification={n} />
          ))}
        </InfiniteScroll>
        {!this.state.hasMore && notifications.length === 0 && (
          <Empty>お知らせはありません</Empty>
        )}
      </Wrapper>
    )
  }

  private async loadMore() {
    try {
      const notifications = this.props.notification.notifications
      const notificationRPC = JSONRPCClientBuilder.build(UserRPC)
      let res: Notification[] = []
      if (notifications.length > 0) {
        res = await notificationRPC.listNotifications({
          lastId: notifications[notifications.length - 1].id,
        })
      } else {
        res = await notificationRPC.listNotifications()
      }

      if (res.length < MAXIMUM_NOTIFICATION_READ_AT_ONE_TIME) {
        this.setState({
          hasMore: false,
        })
      }

      if (res.length > 0) {
        this.bulkReadNotifications(res.map(r => r.id))
        this.props.actions.add(res)
      }
    } catch (e) {
      JSONRPCErrorCatch(e)
    }
  }

  private async bulkReadNotifications(ids: string[]) {
    const notificationRPC = JSONRPCClientBuilder.build(UserRPC)
    await notificationRPC.bulkReadNotifications({ ids })
    const res = await notificationRPC
      .unreadNotificationCount()
      .catch(JSONRPCErrorCatch)
    if (res !== -1) {
      this.props.actions.updateNotificationCount(res.unreadCount)
    }
  }
}

export default container(Component)

const Empty = styled.div`
  padding: 24px 0 48px;
  color: ${Color.DIMGRAY};
  text-align: center;
`
